
import Component from "vue-class-component";
import { ISidebarMenuActionItemProps } from "./ISidebarMenuActionItem";

@Component
export default class SidebarMenuActionItem extends ISidebarMenuActionItemProps {
  private componentClass = "SidebarMenuActionItem";
}
